export default __webpack_public_path__ + "static/media/left_arrow.a7468cd8.svg";